import React from "react";
import { Modal } from "react-bootstrap";

const MembershipSuccessPopup = (props) => {
  return (
    <Modal
      className="membershipSuccess-modal"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => {
          props.setNewModalOpen(true);
          props.setIsSuccessMemberShipModalOpen(false)
        }}
      ></Modal.Header>
      <Modal.Body>
        <div className="post-success-body">
          <div className="success-heading mb-2">Form Submitted!</div>
          <p style={{color:"#161F3D", textAlign:"center"}}>
            Thank you for your submission. We will email you an invoice in the
            next 14 days. Welcome aboard!
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MembershipSuccessPopup;
